import { useQuery } from "react-query"
import { api } from "../services/axios"

export const useGetPlanoUsuario = (id) => {
  return useQuery(["get-plano-usuario"], //Id é cacheado no useQuery, evitar dar um nome que já exista
    async () => {
      if(id != 0 && id != undefined && id != "")
      {
      const { data, status } = await api.get(`planos/${id}`)
      return { data, status }
      }
    },
    {
      //Nem sempre o enabled funciona conforme o esperado
      enabled: id != 0 && id != undefined && id != null
    }
  )
}